import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalComponent } from 'app/components/modal/modal.component';
import { ModalService } from 'app/services/modal.service';

@Component({
    selector: 'psm-unlinkDevice-modal',
    templateUrl: 'unlinkDeviceModal.component.html'
})

export class UnlinkDeviceModalComponent extends ModalComponent<boolean> {

    constructor(modalService: ModalService, router: Router) {
        super(modalService, router);
    }

    public onDeleteAction() {
        this.close(true);
    }

    public onCloseClicked() {
        this.close(false);
    }

    protected onNavigation() {
        this.close(false);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modal/unlinkDeviceModal.component.ts